import React, { useState } from 'react';
import axios from 'axios';
import { useToast } from '../hooks/useToast';

const FeedbackButton = () => {
  const [showModal, setShowModal] = useState(false);
  const [feedback, setFeedback] = useState('');
  const [error, setError] = useState('');
  const toast = useToast();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    if (!feedback.trim()) {
      setError('Feedback cannot be empty.');
      return;
    }

    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/api/feedback`,
        { feedback }
      );
      // Close only once the server has accepted it. The old code closed the
      // modal before the POST, so a failed submission left the draft gone
      // with nothing to show for it.
      setShowModal(false);
      setFeedback('');
      toast.success('Thank you for your feedback!');
    } catch {
      toast.error('Failed to submit feedback. Please try again later.');
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setError(''); // Clear error when closing modal
    setFeedback(''); // Clear feedback text when closing
  };

  return (
    <>
      <button
        title="Provide Feedback"
        onClick={() => setShowModal(true)}
        className="feedback-fab"
      >
        Feedback
      </button>

      {showModal && (
        // Added a modal overlay for better UX (clicking outside closes it)
        <div className="feedback-modal-overlay" onClick={handleCloseModal}>
          <div className="feedback-popout" onClick={(e) => e.stopPropagation()}>
            <h3>Provide Feedback</h3>
            <form onSubmit={handleSubmit}>
              <textarea
                value={feedback}
                onChange={(e) => setFeedback(e.target.value)}
                placeholder="Have a suggestion or found a bug? Let us know!"
                rows="5"
                required
              ></textarea>
              {/* Error message is now displayed above the action buttons */}
              {error && <div className="error-feedback">{error}</div>}
              <div className="feedback-actions">
                <button
                  type="button"
                  onClick={handleCloseModal}
                  className="secondary-button"
                >
                  Cancel
                </button>
                <button type="submit" className="primary-button">
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default FeedbackButton;